import { maybeLocale } from '@wework/universal-locale-utils';
import { varsFromServer } from '../client_side_injection_vars';

export function localizeLink({ to = '/', locale = getLocale() }) {
  const separator = to[0] === '/' ? '' : '/';
  let link = `${maybeLocale(locale)}${separator}${to}`;
  return link;
}

export function getLocale() {
  const DEFAULT_LOCALE = 'en';
  return varsFromServer.locale || DEFAULT_LOCALE;
}
